<template>
  <img src="/images/mcd.svg" alt="mcdonalds" class="h-[calc(112*var(--vh))] w-auto self-end" />
</template>
